<template>
  <div>
    <el-dialog
      title="创建eqb机构章和个人签署账号"
      :visible.sync="jcxy"
      :close-on-click-modal="false"
      width="700px"
      center
    >
      <el-form
        style="padding:0 80px 0 20px;"
        label-width="160px"
        :rules="rules"
        ref="eqbForm"
        :model="choosePerson"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="选择加盟商公司">
              <el-select
                v-model="jmsId"
                @change="getjms"
                style="width:100%"
                clearable
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="(item, index) in allJMSList"
                  :key="index"
                  :label="item.companyName"
                  :value="item.fraId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="城市">
            <el-select
              v-model="cityId"
              clearable
              @change="getcity"
              placeholder="请选择城市"
              filterable
              style="width:100%"
            >
              <el-option
                v-for="(item, index) in cityList"
                :key="index"
                :label="item.cityName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-row>
            <el-form-item label="签署手机" prop="tel">
              <el-input
                v-model="choosePerson.tel"
                maxlength="11"
                clearable
                show-word-limit
                placeholder
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="签署地址(企业地址)" prop="address">
              <el-input v-model="choosePerson.address" clearable show-word-limit placeholder></el-input>
            </el-form-item>
          </el-row>
        </el-row>
        <el-row>
          <el-form-item label="加盟商id">
            <el-input v-model="choosePerson.fraId" clearable placeholder></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="加盟商公司">
            <el-input v-model="choosePerson.companyName" clearable placeholder></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="信用代码">
            <el-input v-model="choosePerson.companyCertificateNo" clearable placeholder></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="法人证件号" prop="legalpersonCertificateNo">
            <el-input v-model="choosePerson.legalpersonCertificateNo" clearable placeholder maxlength="18"  show-word-limit></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="法人姓名" prop="legalpersonName">
            <el-input v-model="choosePerson.legalpersonName" clearable placeholder maxlength="20"></el-input>
          </el-form-item>
        </el-row>
        <!-- <el-row> 
                    <pre>
                    加盟商id: {{ choosePerson.fraId }}
                    加盟商公司:{{ choosePerson.companyName }}
                    信用代码： {{ choosePerson.companyCertificateNo }} 
                    法人证件号: {{ choosePerson.legalpersonCertificateNo }}
        法人证姓名: {{ choosePerson.legalpersonName }}-->
        <!-- 地址： {{ choosePerson.address }} -->
        <!-- 签署手机： {{ choosePerson.tel }}   -->
        <!-- </pre>
        </el-row>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jcxy = false">取消</el-button>
        <el-button type="primary" @click="choose()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import contract from "@/script/api/contractapi";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data";
import {
  validatePhone,
  validateIdNo,
  validateIdNotmust,
  validateIdNoOrNull,
  validateNumber
} from "@/script/validator";
export default {
  data() {
    return {
      id: null,
      jcxy: false,
      PDFVisible: false,
      contractUrl: null,
      allJMSList: [],
      cityList: [],

      jmsId: "",
      cityId: "",
      choosePerson: {
        tel: "",
        legalpersonName: "",
        legalpersonCertificateNo: "",
        address:''
      }, //下拉框所选人
      chooseCity: {},
      rules: {
        tel: [
          { required: true, message: "请输入手机号", trigger: "change" },
          {
            validator: validatePhone,
            message: "手机号格式不对",
            trigger: "blur"
          }
        ],
        address:[
{ required: true, message: "请填写签署地址", trigger: "change" },
        ],
        legalpersonName: [
          { required: true, message: "请输入法人姓名", trigger: "change" }
        ],
        legalpersonCertificateNo: [
          { required: true, message: "请输入法人证件号", trigger: "change" },
          {
            validator: validateIdNo,
            message: "身份证号码格式错误",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    showDetail() {
      this.getAllJMS();
      this.getAllCity();
      this.jcxy = true;
      this.jmsId = "";
      this.cityId = "";
      this.choosePerson = {
           tel: "",
        legalpersonName: "",
        legalpersonCertificateNo: ""
      }; //下拉框所选人
      this.chooseCity = {};
    },

    choose() {
      // if (this.jmsId == "") {
      //   this.$message.warning("请选择公司");
      //   return;
      // }
      if (this.cityId == "") {
        this.$message.warning("请选择城市");
        return;
      }
    //   if (this.choosePerson.tel == "") {
    //     this.$message.warning("请填写签署手机");
    //     return;
    //   }
    //   if (this.choosePerson.address == "") {
    //     this.$message.warning("请填写签署地址");
    //     return;
    //   }
      this.$refs["eqbForm"].validate(valid => {
        if (valid) {
          this.choosePerson.cityId = this.cityId;
          this.choosePerson.cityName = this.chooseCity.cityName;
          contract.$ajaxCreateOneEQBOrg(this.choosePerson).then(res => {
            console.log(res.data.errno);
            if (res.data.errno == 0) {
              this.$message.success("操作成功");
              this.jcxy = false;
            } else {
              this.$message.warning(res.data.data);
            }
          });
        }
      });
    },
    getAllJMS() {
      //城市下拉框
      contract.$ajaxgetNotCreatEQB().then(res => {
        if (res.data.errno == 0) {
          this.allJMSList = res.data.data;
        }
      });
    },
    getAllCity() {
      //城市下拉框
      wmsApi.$axiosgetallCity().then(res => {
        if (res.data.errno == 0) {
          this.cityList = res.data.data;
        }
      });
    },
    getcity(id) {
      let nm = {};
      this.cityList.forEach(e => {
        if (e.id == id) {
          nm = e;
        }
      });
      this.chooseCity = nm;
    },
    getjms(id) {
      let nm = {};
      this.allJMSList.forEach(e => {
        console.log(e);
        if (e.fraId == id) {
          nm = e;
        }
      });
      this.choosePerson = nm;
    }
  }
};
</script>
<style lang="">
</style>